<template>
  <div class="app-container">
    <NavTitle :title="title" @titleClick="handleTitle" />

    <!-- 门店列表 -->
    <Page v-show="tagStep == 0" ref="pageRef" @detail="handlePageDetail" />

    <!-- 门店主页 -->
    <Home v-show="tagStep == 1" ref="homeRef" />
  </div>
</template>

<script>
import Page from "./components/page";
import Home from "./components/home";
import NavTitle from "@/components/NavTitle/index.vue";

export default {
  name: "ChainStore",
  components: {
    Page,
    Home,
    NavTitle,
  },
  data() {
    return {
      tagStep: 0,
      title: ["门店列表"],
    };
  },
  created() {},
  methods: {
    handlePageDetail(row) {
      this.title = ["门店列表", "门店主页"];
      this.tagStep = 1;
      this.$refs.homeRef.homeFetchData(row);
    },
    handleTitle(v, i) {
      this.tagStep = i;
      this.title.splice(i + 1);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
